import { Delete } from '@mui/icons-material';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { CHECKPOINT_GROUP } from '../../consts';
import messages from '../../intl/messages';
import { hideModal } from '../../store/modal/actions';
import { addProcess, deleteProcess, editProcess } from '../../store/model/actions';
import { getConfigDefinitionId } from '../../store/model/selectors';
import UniButtton from '../UniButtton';
import SaveCloseModalTemplate from './SaveCloseModalTemplate';

const useStyles = makeStyles()(() => ({
	deleteIcon: {
		float: 'right',
	},
}));

const parseProcessesIntoArray = (processes) =>
	processes
		.split(',')
		.map((process) => process.trim())
		.filter(Boolean);

const ProcessModal = ({ process }) => {
	const { classes } = useStyles();
	const dispatch = useDispatch();
	const intl = useIntl();
	const creatingMode = isEmpty(process);

	const [name, setName] = useState(creatingMode ? '' : process.name);
	const [processes, setProcesses] = useState(creatingMode ? '' : process.config?.processes.join(', '));
	// Adding defaults to all definitions, editing only touches the current one unless requested
	const [applyToAllDefinitions, setApplyToAllDefinitions] = useState(creatingMode);
	const [saving, setSaving] = useState(false);
	const definitionId = useSelector(getConfigDefinitionId);
	const parsedProcesses = parseProcessesIntoArray(processes);

	const handleAddProcess = async () => {
		setSaving(true);
		const requestOk = await dispatch(
			addProcess(
				{
					name: name.trim(),
					processes: parsedProcesses,
					checkpointGroup: CHECKPOINT_GROUP.PROCESS_ANALYSIS,
					applyToAllDefinitions,
				},
				definitionId,
				intl
			)
		);
		if (requestOk) dispatch(hideModal());
		else setSaving(false);
	};

	const handleEditProcess = async () => {
		setSaving(true);
		const requestOk = await dispatch(
			editProcess(process.id, { name: name.trim(), processes: parsedProcesses, applyToAllDefinitions }, definitionId, intl)
		);
		if (requestOk) dispatch(hideModal());
		else setSaving(false);
	};

	const handleDeleteProcess = () => {
		dispatch(deleteProcess(process.id, definitionId));
		dispatch(hideModal());
	};

	return (
		<SaveCloseModalTemplate
			title={<FormattedMessage {...messages[creatingMode ? 'addProcess' : 'editProcess']} />}
			saveBtnTitle={<FormattedMessage {...messages[creatingMode ? 'addProcess' : 'editProcess']} />}
			onSave={creatingMode ? handleAddProcess : handleEditProcess}
			isSaveBtnDisabled={!name.trim() || parsedProcesses.length === 0 || saving}
		>
			<TextField
				value={name}
				label={<FormattedMessage {...messages.processName} />}
				onChange={(e) => setName(e.target.value)}
				variant="outlined"
				size="small"
				fullWidth
			/>
			<br />
			<br />
			<TextField
				value={processes}
				label={<FormattedMessage {...messages.processes} />}
				onChange={(e) => setProcesses(e.target.value)}
				helperText={<FormattedMessage {...messages.processesHelper} />}
				variant="outlined"
				fullWidth
			/>
			<FormControlLabel
				control={
					<Checkbox checked={applyToAllDefinitions} onChange={() => setApplyToAllDefinitions(!applyToAllDefinitions)} />
				}
				label={
					<FormattedMessage
						{...messages[creatingMode ? 'addProcessToAllDefinitions' : 'editProcessInAllDefinitions']}
					/>
				}
			/>
			{!creatingMode && (
				<UniButtton
					className={classes.deleteIcon}
					tooltip={<FormattedMessage {...messages.deleteProcess} />}
					color="primary"
					onClick={handleDeleteProcess}
					icon={<Delete fontSize="small" />}
				/>
			)}
		</SaveCloseModalTemplate>
	);
};

export default ProcessModal;
